import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
const DashboardIndex = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Dashboard/DashboardIndex.vue')

// Pages
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import PasswordReset from 'src/components/Dashboard/Views/Pages/PasswordReset.vue'
import PasswordResetToken from 'src/components/Dashboard/Views/Pages/PasswordResetToken.vue'

// Components pages
import Orders from 'src/components/Dashboard/Views/Components/Orders.vue'
import Quotes from 'src/components/Dashboard/Views/Components/Quotes.vue'
import Returns from 'src/components/Dashboard/Views/Components/Returns.vue'
import Configuration from 'src/components/Dashboard/Views/Components/Configuration.vue'

// import Customers from 'src/components/Dashboard/Views/Components/Customers.vue'
import Users from 'src/components/Dashboard/Views/Components/Users.vue'
import UsersCRUD from 'src/components/Dashboard/Views/Components/UsersCRUD.vue'

import TradeApplications from 'src/components/Dashboard/Views/Components/TradeApplications.vue'

import Categories from 'src/components/Dashboard/Views/Components/Categories.vue'
import CategoriesCRUD from 'src/components/Dashboard/Views/Components/CategoriesCRUD.vue'
import Manufacturers from 'src/components/Dashboard/Views/Components/Manufacturers.vue'
import ManufacturersCRUD from 'src/components/Dashboard/Views/Components/ManufacturersCRUD.vue'
import Products from 'src/components/Dashboard/Views/Components/Products.vue'
import ProductsCRUD from 'src/components/Dashboard/Views/Components/ProductsCRUD.vue'
import Blacklist from 'src/components/Dashboard/Views/Components/Blacklist.vue'
import BlacklistCRUD from 'src/components/Dashboard/Views/Components/BlacklistCRUD.vue'

import VehicleTypes from 'src/components/Dashboard/Views/Components/VehicleTypes.vue'
import VehicleTypesCRUD from 'src/components/Dashboard/Views/Components/VehicleTypesCRUD.vue'
import Vehicles from 'src/components/Dashboard/Views/Components/Vehicles.vue'
import VehiclesCRUD from 'src/components/Dashboard/Views/Components/VehiclesCRUD.vue'
import Assemblies from 'src/components/Dashboard/Views/Components/Assemblies.vue'
import AssembliesCRUD from 'src/components/Dashboard/Views/Components/AssembliesCRUD.vue'
import Parts from 'src/components/Dashboard/Views/Components/Parts.vue'
import PartsCRUD from 'src/components/Dashboard/Views/Components/PartsCRUD.vue'

import Shipping from 'src/components/Dashboard/Views/Components/Shipping.vue'
import Promotions from 'src/components/Dashboard/Views/Components/Promotions.vue'
import PromotionsCRUD from 'src/components/Dashboard/Views/Components/PromotionsCRUD.vue'
import Blog from 'src/components/Dashboard/Views/Components/Blog.vue'
import Alerts from 'src/components/Dashboard/Views/Components/Alerts.vue'
import AlertsCRUD from 'src/components/Dashboard/Views/Components/AlertsCRUD.vue'

import CMS_Home from 'src/components/Dashboard/Views/Components/CMS_Home.vue'
import CMS_Pages from 'src/components/Dashboard/Views/Components/CMS_Pages.vue'
import CMS_SEO from 'src/components/Dashboard/Views/Components/CMS_SEO.vue'

import Reports from 'src/components/Dashboard/Views/Components/Reports.vue'

import Roles from 'src/components/Dashboard/Views/Components/Roles.vue'
import RolesCRUD from 'src/components/Dashboard/Views/Components/RolesCRUD.vue'
import Syncs from 'src/components/Dashboard/Views/Components/Syncs.vue'
import Scrapes from 'src/components/Dashboard/Views/Components/Scrapes.vue'
import AuditLog from 'src/components/Dashboard/Views/Components/AuditLog.vue'
import Import from 'src/components/Dashboard/Views/Components/Import.vue'

const ordersAndQuotesMenu = {
  path: '/admin/orders',
  component: DashboardLayout,
  meta: {
    guest: false,
    roles: [
      'admin'
    ]
  },
  children: [
    {
      path: 'orders',
      name: 'Orders',
      component: Orders
    },
    {
      path: 'quotes',
      name: 'Quotes',
      component: Quotes
    },
    {
      path: 'returns',
      name: 'Returns',
      component: Returns
    },
    {
      path: 'configuration',
      name: 'Configuration',
      component: Configuration
    }
  ]
}
const customersAndUsersMenu = {
  path: '/admin/users',
  component: DashboardLayout,
  meta: {
    guest: false,
    roles: [
      'admin'
    ]
  },
  children: [
    {
      path: 'trade-applications',
      name: 'Trade Applications',
      component: TradeApplications
    },
    {
      path: 'users',
      name: 'Users',
      component: Users
    },
    {
      path: 'users/:id/:action',
      name: 'Users CRUD',
      component: UsersCRUD
    }
  ]
}
const productsMenu = {
  path: '/admin/products',
  component: DashboardLayout,
  meta: {
    guest: false,
    roles: [
      'admin'
    ]
  },
  children: [
    {
      path: 'categories',
      name: 'Categories',
      component: Categories
    },
    {
      path: 'categories/:id/:action',
      name: 'Categories CRUD',
      component: CategoriesCRUD
    },
    {
      path: 'manufacturers',
      name: 'Manufacturers',
      component: Manufacturers
    },
    {
      path: 'manufacturers/:id/:action',
      name: 'Manufacturers CRUD',
      component: ManufacturersCRUD
    },
    {
      path: '',
      name: 'Products',
      component: Products
    },
    {
      path: 'product/:id/:action',
      name: 'Products CRUD',
      component: ProductsCRUD
    },
    {
      path: 'blacklist',
      name: 'Blacklist',
      component: Blacklist
    },
    {
      path: 'blacklist/:id/:action',
      name: 'Blacklist CRUD',
      component: BlacklistCRUD
    }
  ]
}
const vehiclesMenu = {
  path: '/admin/vehicles',
  component: DashboardLayout,
  meta: {
    guest: false,
    roles: [
      'admin'
    ]
  },
  children: [
    {
      path: 'vehicle-types',
          name: 'VehicleTypes',
        component: VehicleTypes
    },
    {
      path: 'vehicle-types/:id/:action',
      name: 'Vehicle Types CRUD',
      component: VehicleTypesCRUD
    },
    {
      path: 'vehicles',
          name: 'vehicles',
        component: Vehicles
    },
    {
      path: 'vehicles/:id/:action',
      name: 'Vehicle CRUD',
      component: VehiclesCRUD
    },
    {
      path: 'Assemblies',
          name: 'assemblies',
        component: Assemblies
    },
    {
      path: 'assemblies/:id/:action',
      name: 'Assemblies CRUD',
      component: AssembliesCRUD
    },
    {
      path: 'Parts',
          name: 'parts',
        component: Parts
    },
    {
      path: 'parts/:id/:action',
      name: 'Parts CRUD',
      component: PartsCRUD
    }
  ]
}
const cmsMenu = {
  path: '/admin/cms',
  component: DashboardLayout,
  meta: {
    guest: false,
    roles: [
      'admin'
    ]
  },
  children: [
    {
      path: 'home',
      name: 'Home',
      component: CMS_Home
    },
    {
      path: 'pages',
      name: 'Pages',
      component: CMS_Pages
    },
    {
      path: 'seo',
      name: 'SEO',
      component: CMS_SEO
    }
  ]
};
const routes = [
  ordersAndQuotesMenu,
  customersAndUsersMenu,
  productsMenu,
  vehiclesMenu,
  cmsMenu,
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      guest: true,
    }
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    component: PasswordReset,
    meta: {
      guest: true,
    }
  },
  {
    path: '/password-reset-token',
    name: 'password-reset-token',
    component: PasswordResetToken,
    meta: {
      guest: true,
    }
  },
  {
    path: '/admin',
    component: DashboardLayout,
    meta: {
      guest: false,
      roles: [
        'admin'
      ]
    },
    children: [
      {
        path: '',
        name: 'Admin',
        component: DashboardIndex
      },
      {
        path: 'shipping',
        name: 'Shipping',
        component: Shipping
      },
      {
        path: 'promotions',
        name: 'Promotions',
        component: Promotions
      },
      {
        path: 'promotions/:id/:action',
        name: 'Promotions CRUD',
        component: PromotionsCRUD
      },
      {
        path: 'blog',
        name: 'Blog',
        component: Blog
      },
      {
        path: 'alerts',
        name: 'Alerts',
        component: Alerts
      },
      {
        path: 'alerts/:id/:action',
        name: 'Alerts CRUD',
        component: AlertsCRUD
      },
      {
        path: 'reports',
        name: 'Reports',
        component: Reports
      },
      {
        path: 'roles',
        name: 'Roles',
        component: Roles
      },
      {
        path: 'roles/:id/:action',
        name: 'Roles CRUD',
        component: RolesCRUD
      },
      {
        path: 'syncs',
        name: 'Syncs',
        component: Syncs
      },
      {
        path: 'scrapes',
        name: 'Scrapes',
        component: Scrapes
      },
      {
        path: 'audit-log',
        name: 'Audit Log',
        component: AuditLog
      },
      {
        path: 'import',
        name: 'Import',
        component: Import
      }
    ]
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin',
    meta: {
      guest: false,
      roles: [
        'admin'
      ]
    }
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
  },
  {
    path: '*',
    component: NotFound,
    meta: {
      guest: true
    }
  },
  {
    path: '/access-denied',
    component: NotFound,
    meta: {
      guest: true
    }
  }
];

export default routes
